<template>
    <section>
        <v-container class="fill-height" fluid>
            <v-row justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="mx-auto" v-if="!forceMFA">
                        <v-toolbar color="primary" dark>
                            <v-toolbar-title>ARES Login form</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-text-field
                                    label="ID"
                                    v-model="loginId"
                                    prepend-icon="mdi-account"
                                    type="text"
                                    :rules="loginIdRules"
                                    required
                                ></v-text-field>

                                <v-text-field
                                    label="Password"
                                    v-model="password"
                                    prepend-icon="mdi-key-variant"
                                    :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="showNew ? 'text' : 'password'"
                                    :rules="passwordRules"
                                    required
                                    @click:append="showNew = !showNew"
                                    @keyup.enter="doLogin"
                                ></v-text-field>
                                <div v-if="mfaLogin">
                                    <div>
                                        <br>
                                        Open the Authenticator App <img src="@/assets/ms-authenticator.png" width="24"> on your phone<br>
                                        Choose <b>VillaforYou-ARES</b> and supply the 6 digit authentication code.
                                    </div>
                                    <v-text-field
                                        label="Authentication Code"
                                        v-model="mfaCode"
                                        autofocus
                                        required
                                        @keyup.enter="doLogin"
                                    ></v-text-field>
                                </div>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <div class="flex-grow-1"></div>
                            <v-btn color="primary" :disabled="!valid" @click="doLogin">Login</v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-snackbar v-model="snackbar" bottom>
                        {{error_message}}
                    </v-snackbar>
                </v-col>
            </v-row>
            <myAccount :forceMFA="true" :forceMFAuser="loginId" v-if="forceMFA"/>
        </v-container>
    </section>
</template>

<script>
    import myAccount from '@/views/syst/gebr/myaccount/myAccount.vue';

    export default {
        components: {
            myAccount,
        },
        props: {
            source: String,
        },
        data() {
            return {
                valid: true,
                loginId: "",
                snackbar: false,
                showNew: false,
                loginIdRules: [
                    v => !!v || "ID is required",
                    v => (v && v.length >= 2) || "ID is required"
                ],
                password: "",
                passwordRules: [
                    v => !!v || "Password is required",
                    v => (v && v.length >= 6) || "Password must be larger than 6 characters"
                ],
                error_message: "",
                mfaLogin: false,
                mfaCode: "",
                forceMFA: false,
            }
        },
        methods: {
            reset() {
                this.$refs.form.reset();
            },
            doLogin() {
                this.$session.start();
                this.$axios.post("ares/json/ares/misc/login.p", {
                    loginId: this.loginId,
                    password: this.password,
                    mfaCode: this.mfaCode,
                    clientSessionId: this.$session.id(),
                    location: window.location.href,
                }).then(response => {
                    switch(response.data.token) {
                        case "LoginError":
                            this.$store.dispatch('setSnackbar', {
                                showing: true,
                                text: "Login incorrect",
                                color: "error"
                            });
                            this.$session.destroy();
                            break;
                        case "forceMFA":
                            this.forceMFA = true;
                            break;
                        case "mfaLogin":
                            this.mfaLogin = true;
                            break;
                        case "ares2":
                            window.location.href = "https://ares2.villaforyou.net";
                            break;
                        default:
                            localStorage.setItem('login', this.loginId);
                            this.$session.set("ARES", response.data.token);
                            this.$router.push(response.data.dashboard);
                    }
                })
            },
        },
    }
</script>